
import {
    onMounted,
    reactive,
    ref,
    defineComponent,
    getCurrentInstance,
} from 'vue'
import { UsePageDto } from '@/common/mixins/listPageDto'
import formatDate from '@/common/functions/formatDate'
import { message, Modal } from 'ant-design-vue'
import { useStore } from 'vuex'
import SetMenu from './components/SetMenu.vue'

export default defineComponent({
    components: {
        SetMenu,
    },
    setup() {
        const store = useStore()
        const instance = getCurrentInstance()
        const { pagination, listPageDto, handleTableChange } = UsePageDto(
            instance
        )
        const loading = ref<boolean>(false)
        const data = ref([
            {
                id: 1,
                name: '管理员',
            },
            {
                id: 2,
                name: '普通员工',
            },
        ])
        const columns = [
            {
                title: ' 角色ID',
                dataIndex: 'id',
                key: 'id',
            },
            {
                title: '角色名称',
                dataIndex: 'name',
                key: 'name',
            },
            {
                dataIndex: 'action',
                title: '操作',
                slots: { customRender: 'action' },
                width: 200,
            },
        ]

        const configMenuAction = (record: any) => {
            store.commit('setRoleDetail', record)
            store.commit('toggleRoleSetMenuState', true)
        }
        return {
            data,
            columns,
            store,
            configMenuAction,
            formatDate,
            loading,
        }
    },
})
